import { useEffect, useState } from 'react'

import { useResourcesApi } from '@/services/api/resourcesApi'
import { ErrorHandlingStrategy, MessageLevel, SuccessStatus } from '@/types/api'
import { EarlyPaymentDiscount } from '@/types/discounts'

type UseEarlyPaymentDiscountResult = {
    discountDate: EarlyPaymentDiscount | null
    loading: boolean
    error: string | null
}

export const useEarlyPaymentDiscount = (): UseEarlyPaymentDiscountResult => {
    const [discountDate, setDiscountDate] =
        useState<EarlyPaymentDiscount | null>(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)
    const resourcesApi = useResourcesApi({
        messageLevel: MessageLevel.ERRORS,
        errorHandling: ErrorHandlingStrategy.RETURN
    })

    useEffect(() => {
        let isMounted = true

        const fetchDiscountDate = async () => {
            try {
                setLoading(true)

                const response = await resourcesApi.getEarlyPayment()
                const isSuccess =
                    SuccessStatus.ANY_SUCCESS(response.status) && response.data

                if (isSuccess) {
                    if (isMounted) {
                        setDiscountDate(response.data)
                    }
                } else {
                    if (isMounted) {
                        setError('No se pudo obtener la fecha del descuento')
                    }
                }
            } catch (err) {
                console.error(
                    'Error fetching early payment discount date:',
                    err
                )
                if (isMounted) {
                    setError('Error al cargar la fecha del descuento')
                }
            } finally {
                if (isMounted) {
                    setLoading(false)
                }
            }
        }

        fetchDiscountDate()

        return () => {
            isMounted = false
        }
    }, [])

    return {
        discountDate,
        loading,
        error
    }
}
